import { envConfig } from '@/config/envConfig';

type ParamsType = string | Record<string, string> | string[][] | URLSearchParams;

export const urlHelper = (uri: string, params?: ParamsType) => {
  let finalUrl = `${envConfig.BASE_URL_PREFIX}${uri}`;

  if (params && Object.keys(params)?.length) {
    const searchParamsString = new URLSearchParams(params).toString();

    finalUrl = `${finalUrl}?${searchParamsString}`;
  }

  return finalUrl;
};

export const getHostnameFromUrl = (url: string = '') => {
  try {
    const urlData = new URL(url);

    return urlData?.hostname;
  } catch (error) {
    console.error('[getHostnameFromUrl] Invalid URL:', error);
  }
};

export const hasSameDomain = (url: string = '') => {
  const hostname = getHostnameFromUrl(url);

  return window.location.hostname.includes(hostname);
};
